import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$9 } from './box.js';
import { d as defineCustomElement$8 } from './button.js';
import { d as defineCustomElement$7 } from './divider.js';
import { d as defineCustomElement$6 } from './icon.js';
import { d as defineCustomElement$5 } from './loader.js';
import { d as defineCustomElement$4 } from './status.js';
import { d as defineCustomElement$3 } from './tooltip.js';
import { d as defineCustomElement$2 } from './tooltip-label.js';

const expandableTileCss = ".header-wrapper{align-items:center;background:none;border:none;color:inherit;cursor:pointer;display:inline-flex;font-size:inherit;justify-content:flex-start;margin:0;padding:0;width:100%}.header-wrapper:disabled{cursor:not-allowed}:host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;border:1px solid var(--jw-theme-surface-border-border-color);border-radius:.375rem;box-sizing:border-box;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;width:100%}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host header{align-items:center;background:var(--jw-theme-surface-tile-bg-color);border-radius:.375rem;display:flex;justify-content:space-between;padding:1.5rem;width:100%}:host .body-container{background-color:var(--jw-theme-surface-tile-bg-color);display:none;flex-direction:column;padding:1.5rem}:host .footer-container{padding-top:1rem}:host h3{color:var(--jw-theme-surface-text-default-color);font-family:Open Sans;font-size:1.125rem;font-weight:400;letter-spacing:-.0008em;line-height:1.5rem;margin:0}:host h4{color:var(--jw-theme-surface-text-default-color);font-family:Open Sans;font-size:1rem;font-weight:600;letter-spacing:-.0008em;line-height:1.5rem;margin:0}:host .property-slots-container{display:flex;gap:1rem}:host .property-slots-chevron-group{align-items:center;display:flex;gap:1rem}:host .property-slot{align-items:center;color:var(--jw-theme-surface-text-description-color);display:flex}:host .tile-content{background-color:var(--jw-theme-surface-tile-bg-color)}:host .content{display:flex;flex-direction:column;gap:1.5rem}:host([expanded]) .body-container{border-bottom-left-radius:.375rem;border-bottom-right-radius:.375rem;display:flex}:host([expanded]) header{border-bottom:1px solid var(--jw-theme-surface-border-border-color);border-bottom-left-radius:0;border-bottom-right-radius:0}:host([nested]) header{background:var(--jw-theme-surface-level1-default-bg-color)}:host([nested]) .body-container{background-color:var(--jw-theme-surface-level1-default-bg-color);border-radius:.375rem}:host([nested]) .body-container,:host([nested]) .footer-container,:host([nested]) .tile-content{background-color:var(--jw-theme-surface-level1-default-bg-color)}";
const WuiExpandableTileStyle0 = expandableTileCss;

const WuiExpandableTile$1 = /*@__PURE__*/ proxyCustomElement(class WuiExpandableTile extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.expandedChange = createEvent(this, "expandedChange", 7);
        this.toggleExpanded = () => {
            if (this.disabled) {
                return;
            }
            this.expanded = !this.expanded;
            this.expandedChange.emit(this.expanded);
        };
        this.renderPropertySlot = (propertySlot) => {
            if (propertySlot === null || propertySlot === undefined || propertySlot === '') {
                return null;
            }
            if (typeof propertySlot === 'string') {
                return h("span", { class: "property-slot" }, propertySlot);
            }
            return h("wui-status", { ...propertySlot });
        };
        this.hasFooter = () => {
            return this.elm.querySelector('[slot="footer"]') !== null;
        };
        this.contentBox = undefined;
        this.header = '';
        this.propertySlots = [];
        this.nested = false;
        this.expanded = false;
        this.disabled = false;
    }
    render() {
        const slotsWithDividers = [];
        const defaultBoxProps = {
            padding: 0,
        };
        const boxProps = typeof this.contentBox === 'object' ? this.contentBox : {};
        this.propertySlots.forEach((propertySlot, index) => {
            slotsWithDividers.push(this.renderPropertySlot(propertySlot));
            if (index !== this.propertySlots.length - 1) {
                slotsWithDividers.push(h("wui-divider", { type: "vertical" }));
            }
        });
        return (h(Host, { key: '1977e98847b04d467a30d62655b8b4d45d43ccbc' }, h("button", { key: '7e0789f737aa56cf8cb17ec071820f61b42f431c', class: "header-wrapper", disabled: this.disabled, onClick: this.toggleExpanded }, h("header", { key: 'd48392e5118fc139a80bd24d2bde29b754eccaab' }, this.nested ? h("h4", null, this.header) : h("h3", null, this.header), h("div", { key: '7437cc08726a14f0ff1afc9b67e1c86a7a1936d5', class: "property-slots-chevron-group" }, h("div", { key: '4af2997cf90f6a22a8b8a087379b9f46a1a10c6c', class: "property-slots-container" }, slotsWithDividers), h("wui-button", { key: '108ba610a7c0e906f1c9c00ccd1150c75f680f01', type: "icon-ghost", icon: this.expanded ? 'chevron-up' : 'chevron-down', tooltip: this.expanded ? 'Collapse' : 'Expand', disabled: this.disabled })))), h("div", { key: '873a0d52ce8d8fb31b4ab9ac280aa9b7b9839494', class: "body-container" }, h("div", { key: '0e571e64926dd50ff3f489c5fe7c1bcdf2a0238e', class: "content" }, h("wui-box", { key: '32c7d39960655262daa8968f5379073330aee295', style: { flex: '1' }, ...defaultBoxProps, ...(this.expanded ? boxProps : { ...boxProps, padding: 0 }) }, h("slot", { key: 'e22c89d9b1f36ab58759b63f58eb9929d8477af6' })), this.hasFooter() && h("wui-divider", { key: '7de05f8a7706d63f28184019d67b1632149d79e0', type: "horizontal" })), this.hasFooter() && (h("div", { key: 'a68deba13f169c2e87048dded140706e83eb1286', class: "footer-container" }, h("slot", { key: '54432f29afaa1bfa89a606fd90d1d05e65eb8b15', name: "footer" }))))));
    }
    get elm() { return this; }
    static get style() { return WuiExpandableTileStyle0; }
}, [1, "wui-expandable-tile", {
        "contentBox": [4, "content-box"],
        "header": [1],
        "propertySlots": [16],
        "nested": [516],
        "expanded": [1540],
        "disabled": [516]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-expandable-tile", "wui-box", "wui-button", "wui-divider", "wui-icon", "wui-loader", "wui-status", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-expandable-tile":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiExpandableTile$1);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "wui-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "wui-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-status":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiExpandableTile = WuiExpandableTile$1;
const defineCustomElement = defineCustomElement$1;

export { WuiExpandableTile, defineCustomElement };

//# sourceMappingURL=wui-expandable-tile.js.map